import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  updateRole,
  fetchRole,
} from '../../../../redux/actions/roles&permissions/roles';
import { showToast } from '../../../../redux/actions/toasts';
import Edit from './Edit';

const mapDispatchToProps = (dispatch) => ({
  updateRole: (roleId, data) => dispatch(updateRole(roleId, data)),
  fetchRole: (roleId) => dispatch(fetchRole(roleId)),
  showToast: (message) => dispatch(showToast({ message })),
});

export default withRouter(connect(null, mapDispatchToProps)(Edit));
